var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hostPort)?_c('div',[_vm._v("\n  "+_vm._s(_vm.hostPort+'/'+_vm.protocol)+"\n")]):_c('div',[_vm._v("\n  —\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }